import { Component, OnDestroy, OnInit } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import { SpasLicenseService } from '../../../../services/admin/plant-setup/spas-license.service'
import { HttpResponseHandlerService } from '../../../../services/http-response-handler.service'
import { Subscription } from 'rxjs'

@Component({
    selector: 'app-license-notification',
    templateUrl: './license-notification.component.html',
    styleUrls: ['./license-notification.component.scss'],
    standalone: false
})
export class LicenseNotificationComponent implements OnInit, OnDestroy {
  private _hasWarning: boolean = false
  private _hasAlert: boolean = false
  private _licenseSubscription: Subscription

  constructor(
    private service: SpasLicenseService,
    private handlerResponseService: HttpResponseHandlerService,
  ) {}

  public displayAlert(): boolean {
    return this._hasAlert
  }

  public displayWarning(): boolean {
    return !this._hasAlert && this._hasWarning
  }

  private getLicenseStatus(reload: boolean = false): void {
    this.service.getLicenseStatus(reload).subscribe(
      (response: { installed: boolean; warnings: number; alerts: number }) => {
        if (response.installed) {
          this._hasAlert = response.alerts > 0
          this._hasWarning = response.warnings > 0
        } else {
          this._hasAlert = true
        }
      },
      (error: HttpErrorResponse) => {
        this.handlerResponseService.notifyError(error)
      },
    )
  }

  private checkLicenseNotification(): void {
    this._licenseSubscription = this.service.licenseChangeEvent.subscribe((changed: boolean) => {
      if (changed) {
        this.getLicenseStatus(true)
      }
    })
  }

  ngOnInit(): void {
    this.getLicenseStatus()
    this.checkLicenseNotification()
  }

  ngOnDestroy() {
    if (this._licenseSubscription) {
      this._licenseSubscription.unsubscribe()
    }
  }
}
